var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddConfirmation',{ref:"AddConfirmationModal",attrs:{"warnText":"O relatório será enviado no seu e-mail","saveFunction":_vm.confirm}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31df7d02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/configurations/lista-inteligente/components/add/modal/SendExcelEmailConfirmationModal.vue
// module id = null
// module chunks = 